import StockSearchItemBase from "@/classes/stock/StockSearchItemBase";

export default class PickStockSearchItem extends StockSearchItemBase {

    constructor() {
        super();
    }
}
